import rankFragmentsWithMatchesCount from 'bl/client/rankFragmentsWithMatchesCount.bl';
import rankMatchesAtStartOfFragmentsCount from 'bl/client/rankMatchesAtStartOfFragmentsCount.bl';
import rankPerfectMatch from 'bl/client/rankPerfectMatch.bl';
import rankStartOfFirstFragment from 'bl/client/rankStartOfFirstFragment.bl';
import splitText from 'bl/client/splitText.bl';
import fromAnyToLowerCase from 'utils/converters/any/fromAnyToLowerCase.util';
import fromAnyToString from 'utils/converters/fromAnyToString';

const calculateNicknameRank = (options) => {
  const text = options?.text;
  const nickname = fromAnyToString(options?.nickname);

  const lowered = fromAnyToLowerCase(nickname);
  const strings = nickname ? splitText(lowered) : [];

  // let's score how well text matches  user.user_name
  let rank = 0;
  rank += nickname ? rankPerfectMatch({ a: text, b: lowered }) : 0;
  rank += rankFragmentsWithMatchesCount({ text, strings });
  rank += rankMatchesAtStartOfFragmentsCount({ text, strings });
  rank += rankStartOfFirstFragment({ text, strings });

  return rank;
};

export default calculateNicknameRank;
